import { CampanhaUsuarioService } from "../../../services/campanhaUsuario/campanhaUsuarioService";
import { AprovarPedidoService } from "../../../services/aprovarPedido/aprovarPedidoService";
import { CampanhaUsuarioResponse } from "../../../types/campanhaUsuario/campanhaUsuarioResponse";
import { CampanhaPedidoExtratoResponse } from "../../../types/campanhaPedidoExtrato/campanhaPedidoExtratoResponse";
import { UltimaOperacaoResponse } from "../../../types/aprovarPedido/ultimaOperacaoResponse";
import { AprovarPedidoDetalhesProps } from "../../../views/aprovarPedido/components/aprovarPedidoDetalhes";

export default class AprovarPedidoDetalhesContainer {
  public props: AprovarPedidoDetalhesProps;
  private campanhaUsuarioService: CampanhaUsuarioService;
  private aprovarPedidoService: AprovarPedidoService;

  constructor(props: AprovarPedidoDetalhesProps) {
    this.props = props;
    this.campanhaUsuarioService = new CampanhaUsuarioService();
    this.aprovarPedidoService = new AprovarPedidoService();
  }
  async GetCampanhaUsuario(usuarioId: number, campanhaId: number) : Promise<CampanhaUsuarioResponse> {
    const result = await this.campanhaUsuarioService.GetCampanhaUsuario(usuarioId, campanhaId);
    if (result instanceof Error) {
      throw result;
    }
    return result;
  }

  async GetCampanhaPedidoExtrato(usuarioId: number, campanhaId: number): Promise<CampanhaPedidoExtratoResponse[]> {
    const result = await this.campanhaUsuarioService.GetCampanhaPedidoExtrato(usuarioId, campanhaId);
    if (result instanceof Error) {
      throw result;
    }
    return result;
  }

  async GetUltimaOperacao(campanhaPedidoResgateId: number): Promise<UltimaOperacaoResponse | null> {
    return await this.aprovarPedidoService.GetUltimaOperacao(campanhaPedidoResgateId);
  }
}

// import { CampanhaComponentProps } from "../../views/campanha/campanha"

// export interface CampanhaContainerProps { }

// export default class CampanhaContainer {
//   public props : CampanhaComponentProps

//   constructor(props : CampanhaComponentProps) {
//     this.props = props
//   }
  
//   public GetExemplo = () => {
//     this.props.GetExemplo()
//   }
// }
